
document.addEventListener('DOMContentLoaded', () => {
    const productAccordions = document.querySelectorAll('.tabs-accordion details-accordion');
    productAccordions.forEach(accordion => {
        const mainContent = accordion.querySelector('.tabs-accordion__accordion__content-inner');
        if (!mainContent?.querySelector('.metafield-single_line_text_field')) {
            accordion.style.display = "none";
            let sibling = accordion.previousElementSibling;
            while (sibling) {
                if (sibling.tagName === 'HR') {
                    sibling.style.display = "none";
                    break;
                }
                sibling = sibling.previousElementSibling;
            }
        }
    });
});
